import { render, staticRenderFns } from "./ChemPropsWithCopyCard.vue?vue&type=template&id=80940b86&scoped=true"
import script from "./ChemPropsWithCopyCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ChemPropsWithCopyCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ChemPropsWithCopyCard.vue?vue&type=style&index=0&id=80940b86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80940b86",
  null
  
)

export default component.exports